import { render } from "./MoreContent.vue?vue&type=template&id=14146bbe&ts=true"
import script from "./MoreContent.vue?vue&type=script&lang=ts"
export * from "./MoreContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__